// modèle : INDISPONIBLE 9010 - Blanc
// ATTENTION à respecter ce format de couleur sinon bugs de "découpe" de la string
export const CONST_COLORS = [{
	text: '5008 - Bleu ardoise',
	value: 0x273038,
	atg: true
}, {
	text: '8012 - Brun rouge',
	value: 0x541f1f,
	atg: true
}, {
	text: '6011 - Vert réséda',
	value: 0x5e7d4f
}, {
	text: '6021 - Vert pâle',
	value: 0x85a67a
}, {
	text: '6005 - Vert mousse',
	value: 0x0a391f
}, {
	text: '7022 - Gris terre',
	value: 0x3d3d3b
}, {
	text: '7006 - Brun lauze',
	value: 0x6b6157
}, {
	text: '8024 - Bois',
	value: 0x6e4030
}, {
	text: '1019 - Gris beige',
	value: 0xa38c7a
}, {
	text: '1015 - Sable',
	clear: true,
	value: 0xfcebcc
}, {
	text: '9002 - Gris pierre',
	clear: true,
	value: 0xf0ede6,
	atg: true
}, {
	text: '9010 - Blanc',
	clear: true,
	value: 0xfaffff
}, {
	text: '9006 - Gris alu',
	clear: true,
	value: 0xa6abb5
}, {
	text: '7015 - Gris graphite',
	value: 0x3d4252,
	atg: true
}, {
	text: '7016 - Gris anthracite',
	value: 0x262e38,
	atg: true
}];
